import React from 'react';
import { observer } from 'mobx-react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { APP_ROUTES } from './utils/constants';
import store from './stores/';

import Session from './Pages/Session';
import Unauthorized from './Pages/Unauthorized';

import MainLayout from './Layouts/MainLayout';

const stores = {store};

const App = observer(() => {
    return (
      <>
      <ToastContainer />      
        <BrowserRouter>
          <Routes>
              <Route path={APP_ROUTES.SESSION} exact element={<MainLayout {...stores}><Session {...stores} /> </MainLayout>} />
              <Route path={APP_ROUTES.UNAUTHORIZED} exact element={<MainLayout {...stores}><Unauthorized {...stores} /> </MainLayout>} />
          </Routes>
        </BrowserRouter>
      </>
    );
  }
);

export default App;
